import React from "react";

/**
 * Ascend Tech Solutions — official brand mark.
 * Renders the uploaded logo image (mark only) as-is.
 * The wordmark ("Ascend Tech Solutions") is set separately in the header/footer.
 */
export default function Logo({
  className = "h-11 w-auto",
  alt = "Ascend Tech Solutions",
}) {
  return (
    <img
      src="/logo.png"
      alt={alt}
      className={className}
      draggable={false}
      loading="eager"
      decoding="sync"
      style={{ imageRendering: "auto" }}
    />
  );
}
